export default __webpack_public_path__ + "static/media/loading.89906e12.gif";